import { ImageCarouselSlide } from '@dfh-corp-sites/ui'
import React from 'react'

import { getResizedImageUrl } from '../../../lib/sanity'
import Link from '../../global/Link'
import SanityLink from '../../global/SanityLink'
import { CarouselCta, CarouselImageAsset, SanityImageCarouselSlide } from './types'

export const transformImage = (
  imageAsset: CarouselImageAsset | undefined | null,
  width: number,
  altText?: string,
) => {
  // Handle cases where imageAsset is undefined, null, or doesn't have an asset property
  if (!imageAsset || !imageAsset.asset || !imageAsset.asset.url) {
    return {
      src: '',
      alt: altText || 'Image',
      loading: 'lazy' as const,
    }
  }

  const { asset } = imageAsset

  return {
    src:
      getResizedImageUrl(asset, {
        dpr: 2,
        fit: 'max',
        width,
      }) || asset?.url,
    alt: altText || '',
    loading: 'lazy' as const,
  }
}

const getTeamMemberUrl = ({
  slug,
  type,
}: {
  slug?: string
  type?: 'teamMemberScience' | 'teamMemberLeadership'
}) => {
  if (type && slug) {
    const basePath = type === 'teamMemberScience' ? '/our-story/science/' : '/our-story/leadership/'
    return `${basePath}${slug}`
  }
  return '#'
}

export const transformImageSlide = (slide: SanityImageCarouselSlide): ImageCarouselSlide => {
  // If it's a team member, handle that case
  if (slide.teamMember) {
    const { name, title, photo, slug, _type } = slide.teamMember
    return {
      ...slide,
      image: transformImage(photo, 322, photo.asset.altText || name),
      imageName: name,
      imageTitle: title,
      imageBio: slide.imageBio,
      renderLink: (children: React.ReactNode) => {
        return (
          <Link
            aria-label={`View ${name}`}
            to={getTeamMemberUrl({
              slug: slug?.current,
              type: _type,
            })}
          >
            {children}
          </Link>
        )
      },
    }
  }

  // Otherwise, use the original logic that was working
  return {
    ...slide,
    image: transformImage(slide.image, 322, slide.image?.asset?.altText),
  }
}

export const transformLink = (cta?: CarouselCta, key?: string): React.ReactNode => {
  if (!cta) return undefined

  return cta.link?.target?.length > 0 ? (
    <SanityLink key={key} to={cta.link}>
      {cta.title}
    </SanityLink>
  ) : (
    cta.title
  )
}
